import React, { useContext, useCallback, useEffect, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { NavLink, useLocation } from 'react-router-dom'
import Row from '../../../components/Row'
import { userInfo } from '../../../constants/usercenter'
import { getArtist } from '../../../service/user'
import { useActiveWeb3React } from '../../../hooks'
import { GetQueryString } from '../../../utils/func'

const TabsWrapper = styled.div`
  padding: 22px 40px 11px;
  padding-right: 0px;
  width: 1204px;
  height: auto;
  background: ${({ theme }) => theme.bsBg10};
  font-weight: normal;
  border: 1px solid ${({ theme }) => theme.bg3};
  box-sizing: border-box;
  border-radius: 10px;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100% - 40px);
  `}
`
const WrapperItem = styled(Row)`
  position: relative;
  margin: 0 auto 10px;
  max-width: 1180px;
  line-height: 29px;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    max-width: 100%;
    flex-wrap: wrap;
  `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 90%;
    flex-wrap: wrap;
  `}
`
const ItemTitle = styled.div`
  flex-shrink: 0;
  align-self: flex-start;
  white-space: nowrap;
  margin-right: 24px;
  font-family: Baloo Da;
  font-size: 17px;
  position: relative;
  color: ${({ theme }) => theme.bsText7};
`
const ItemRow = styled(Row)`
  flex-shrink: 1;
  width: 100%;
  flex-wrap: wrap;
`
const activeclass = 'ACTIVENAV'
const TabItem = styled(NavLink).attrs({
  activeclass
})`
  position: relative;
  color: ${({ theme }) => theme.bsText2};
  font-size: 16px;
  font-family: Yuanti SC;
  font-weight: bold;
  text-decoration: none;
  white-space:nowrap;
  margin-right: 32px;
  
  &.${activeclass} {
    padding: 0 10px;
    height: 24px;
    line-height: 22px;
    color: ${({ theme }) => theme.bsBg10};
    background: ${({ theme }) => theme.bsBg4};
    border-radius: 8px;
    // &:after {
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   background: ${({ theme }) => theme.text1};
    //   border-radius: 2px;
    //   width: 100%;
    //   height: 4px;
    // }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
    margin-right: 16px;
    &.${activeclass} {
      font-size: 14px;
    }
  `};
`

const IconFlag =  styled.img`
  position: absolute;
  top: -10px;
  right: -15px;
`
const activeScroll = 'ACTIVESCROLL'
const ScrollBox = styled.div`
  max-width: 970px;
  width: 970px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  a {
    margin-right: 21px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `};
`
const More = styled.span.attrs({activeScroll})`
  align-self: flex-start;
  position: absolute;
  right: 20px;
  height: 20px;
  width: 72px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: ${({theme}) => theme.bsText7};
  margin-left: -20px;
  border-radius: 6px;
  padding: 0 5px;
  border: 1px solid ${({theme}) => theme.bsText2};
  font-family: 'Yuanti SC';
  img{
    margin-left: 5px;
    margin-top: -2px;
    margin-bottom: 2px;
    transition: .3s all;
  }
  &.${activeScroll}{
    img {
      -ms-transform:rotate(180deg);
      -webkit-transform:rotate(180deg);
      transform: rotate(180deg);
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    position: relative; left: 20px;
  `};
`

export default function Tabs() {
  const location = useLocation()
  const theme = useContext(ThemeContext)
  const { chainId } = useActiveWeb3React()
  const [artistList, setArtistList] = useState([])

  const getArtistList = useCallback(() => {
    getArtist(chainId as number, {addressTypes: '4'}, (err: any, d: any) => {
      if (!err && d.code === 0) {
        const list = d.data || []
        setArtistList(list.length ? list : userInfo)
      } else {
        setArtistList(userInfo as any)
      }
    })
  }, [chainId])

  useEffect(() => {
    getArtistList()
  }, [getArtistList])

  // const userList = userInfo
  const[isScroll, setIsScroll] = useState(false)
  const scroll = () => {
    setIsScroll(!isScroll)
  }
  let search: string = GetQueryString('type', location.search)

  return (
    <TabsWrapper>
      {/* <WrapperItem>
        <ItemTitle>Upcoming Drops:<IconFlag src={'/images/icon_hot' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} /></ItemTitle>
        <TabItem to={'/exchange/new-artworks/artworkInfo/13277/0/1'} className={location.pathname === '/exchange/new-artworks/artworkInfo/13277/0/1' ? activeclass : ''}>
          CaoJunNFT Collectibles 0604
        </TabItem>
        <TabItem to={'/exchange/new-artworks/artworkInfo/13278/0/1'} className={(location.pathname.indexOf('/exchange/new-artworks/artworkInfo/13278/0/1') >= 0 || location.pathname.indexOf('/exchange/soccer') >= 0) ? activeclass : ''}>
          CaoJunNFT Collectibles 9135
        </TabItem>
        <TabItem to={'/exchange/new-artworks/artworkInfo/13283/0/1'} className={location.pathname === '/exchange/new-artworks/artworkInfo/13283/0/1' ? activeclass : ''}>
          CaoJunNFT Collectibles 7613
        </TabItem>
        <TabItem to={'/exchange/new-artworks/artworkInfo/13284/0/1'} className={location.pathname === '/exchange/new-artworks/artworkInfo/13284/0/1' ? activeclass : ''}>
          CaoJunNFT Collectibles 8300
        </TabItem>
      </WrapperItem> */}
      <WrapperItem>
        <ItemTitle>Featured Artists:</ItemTitle>
        <ScrollBox>
          {
            artistList.map((d: any, i: number) => {
              if (i > 8 && !isScroll) return null
              return (
                <TabItem
                  key={i}
                  to={`/usercenter/${d.address}`} 
                >
                  { d.nick }
                </TabItem>
              )
            })
          }
        </ScrollBox>
        {
          artistList.length > 9 &&
          <More onClick={() => scroll()} className={isScroll ? activeScroll : ''}>
            More
            <img src="/static/media/icon_arrow_tab.6c2903d3.svg" alt=""/>
          </More>
        }
      </WrapperItem>
      <WrapperItem>
        <ItemTitle>Mintable Artworks and Meme:</ItemTitle>
        <ItemRow>
          <TabItem to={'/exchange/bakery-artworks/111,3'} className={(location.pathname === '/exchange/bakery-artworks/111,3' || ['3', '111'].includes(search)) ? activeclass : ''}>
            BSC Artists
            <IconFlag src={'/images/icon_hot' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/105'} className={(location.pathname === '/exchange/bakery-artworks/105' || ['105'].includes(search)) ? activeclass : ''}>
            Love Meme
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/101'} className={(location.pathname === '/exchange/bakery-artworks/101' || ['101'].includes(search)) ? activeclass : ''}>
            Safepal Meme
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/4'} className={(location.pathname === '/exchange/bakery-artworks/4' || ['4'].includes(search)) ? activeclass : ''}>
            Musk&Doge
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/8'} className={(location.pathname === '/exchange/bakery-artworks/8' || ['8'].includes(search)) ? activeclass : ''}>
            1inch&BAKE
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/5'} className={(location.pathname === '/exchange/bakery-artworks/5' || ['5'].includes(search)) ? activeclass : ''}>
            BAKE&Banana
          </TabItem>
        </ItemRow>
      </WrapperItem>
      <WrapperItem>
        <ItemTitle>Partner Shops:</ItemTitle>
        <ItemRow>
          <TabItem to={'/exchange/bakery-artworks/119'} className={(location.pathname === '/exchange/bakery-artworks/119' || ['119'].includes(search)) ? activeclass : ''}>
            Blin
            <IconFlag src={'/images/icon_new' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/112'} className={(location.pathname === '/exchange/bakery-artworks/112' || ['112'].includes(search)) ? activeclass : ''}>
            TOKAU
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/107,113,117,118'} className={(location.pathname === '/exchange/bakery-artworks/107,113,117,118' || ['107', '113', '117', '118'].includes(search)) ? activeclass : ''}>
            RACA
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/116'} className={(location.pathname === '/exchange/bakery-artworks/116' || ['116'].includes(search)) ? activeclass : ''}>
            KAKA
          </TabItem>
          {/* <TabItem to={'/exchange/bakery-artworks/1'} className={(location.pathname === '/exchange/bakery-artworks/1' || ['1'].includes(search)) ? activeclass : ''}>
            BCA Studio
          </TabItem> */}
          <TabItem to={'/exchange/bakery-artworks/6'} className={(location.pathname === '/exchange/bakery-artworks/6' || ['6'].includes(search)) ? activeclass : ''}>
            Seascape
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/109'} className={location.pathname === '/exchange/bakery-artworks/109' ? activeclass : ''}>
            YooShi 
          </TabItem>
          <TabItem to={'/exchange/binance-nft'} className={location.pathname === '/exchange/binance-nft' ? activeclass : ''}>
            Binance 
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/7'} className={location.pathname === '/exchange/bakery-artworks/7' ? activeclass : ''}>
            Tokocrypto
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/110'} className={location.pathname === '/exchange/bakery-artworks/110' ? activeclass : ''}>
            Bondly
          </TabItem>
        </ItemRow>
      </WrapperItem>
      <WrapperItem>
        <ItemTitle>Collectibles and Game Assets:</ItemTitle>
        <ItemRow>
          <TabItem to={'/exchange/bakery-artworks/121'} className={(location.pathname === '/exchange/bakery-artworks/121' || ['121'].includes(search)) ? activeclass : ''}>
            Binamon
            <IconFlag src={'/images/icon_new' + (theme.darkMode ? '_light' : '') + '.svg'} width={24} />
          </TabItem>
          <TabItem to={'/exchange/bakery-artworks/115,120'} className={(location.pathname === '/exchange/bakery-artworks/115,120' || ['115', '120'].includes(search)) ? activeclass : ''}>
            Alchemy Toys
          </TabItem>
          <TabItem to={'/exchange/doggynft'} className={location.pathname.indexOf('/exchange/doggynft') >= 0 ? activeclass : ''}>
            Crypto Doggies
          </TabItem>
          <TabItem to={'/exchange/barkingnft'} className={location.pathname.indexOf('/exchange/barkingnft') >= 0 ? activeclass : ''}>
            Barking Sounds
          </TabItem>
          <TabItem to={'/exchange/doggyEquipment'} className={location.pathname.indexOf('/exchange/doggyEquipment') >= 0 ? activeclass : ''}>
            Doggy Equipment
          </TabItem>
          <TabItem to={'/exchange/pokernft'} className={location.pathname.indexOf('/exchange/pokernft') >= 0 ? activeclass : ''}>
            Poker 
          </TabItem>
          <TabItem to={'/exchange/rareCar'} className={location.pathname.indexOf('/exchange/rareCar') >= 0 ? activeclass : ''}>
            Rare Car
          </TabItem>
          <TabItem to={'/exchange'} className={location.pathname === '/exchange' ? activeclass : ''}>
            Bakery Combos
          </TabItem>
          <TabItem to={'/exchange/bakerySoccer'} className={(location.pathname.indexOf('/exchange/bakerySoccer') >= 0 || location.pathname.indexOf('/exchange/soccer') >= 0) ? activeclass : ''}>
            Soccer Ball
          </TabItem>
          <TabItem to={'/exchange/pets'} className={location.pathname === '/exchange/pets' ? activeclass : ''}>
            Battle Pets
          </TabItem>
          <TabItem to={'/exchange/weapons'} className={location.pathname === '/exchange/weapons' ? activeclass : ''}>
            Weapons
          </TabItem>
          <TabItem to={'/exchange/pet-eggs'} className={location.pathname === '/exchange/pet-eggs' ? activeclass : ''}>
            Pet Eggs
          </TabItem>
        </ItemRow>
      </WrapperItem>
    </TabsWrapper>
  )
}